"use client";

import { useViewportCalculator } from "@/hooks/useViewportCalculator";

export const ViewPortCalculator = (): null => {
  useViewportCalculator();

  return null;
};
